import "core-js/stable";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import * as serviceWorker from "./serviceWorker";
import store from "./store/store";

import App from "./App";
import Notifications from "./common/components/Notification";

ReactDOM.render(
  <Provider store={store}>
    <App />
    <Notifications />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
